// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilingJobStatus } from './filing-job-status';
import {
    FilingJobStatusFromJSON,
    FilingJobStatusFromJSONTyped,
    FilingJobStatusToJSON,
    FilingJobStatusToJSONTyped,
} from './filing-job-status';

/**
 * 
 * @export
 * @interface VtmfFilingJob
 */
export interface VtmfFilingJob {
    /**
     * 
     * @type {number}
     * @memberof VtmfFilingJob
     */
    attempts: number;
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingJob
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingJob
     */
    dta_id: string;
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingJob
     */
    filing_job_id: string;
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingJob
     */
    idempotency_key: string;
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingJob
     */
    last_error?: string;
    /**
     * 
     * @type {FilingJobStatus}
     * @memberof VtmfFilingJob
     */
    status: FilingJobStatus;
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingJob
     */
    updated_at: string;
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingJob
     */
    vtmf_reference?: string;
}



/**
 * Check if a given object implements the VtmfFilingJob interface.
 */
export function instanceOfVtmfFilingJob(value: object): value is VtmfFilingJob {
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('filing_job_id' in value) || value['filing_job_id'] === undefined) return false;
    if (!('idempotency_key' in value) || value['idempotency_key'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function VtmfFilingJobFromJSON(json: any): VtmfFilingJob {
    return VtmfFilingJobFromJSONTyped(json, false);
}

export function VtmfFilingJobFromJSONTyped(json: any, ignoreDiscriminator: boolean): VtmfFilingJob {
    if (json == null) {
        return json;
    }
    return {
        
        'attempts': json['attempts'],
        'created_at': json['created_at'],
        'dta_id': json['dta_id'],
        'filing_job_id': json['filing_job_id'],
        'idempotency_key': json['idempotency_key'],
        'last_error': json['last_error'] == null ? undefined : json['last_error'],
        'status': FilingJobStatusFromJSON(json['status']),
        'updated_at': json['updated_at'],
        'vtmf_reference': json['vtmf_reference'] == null ? undefined : json['vtmf_reference'],
    };
}

export function VtmfFilingJobToJSON(json: any): VtmfFilingJob {
    return VtmfFilingJobToJSONTyped(json, false);
}

export function VtmfFilingJobToJSONTyped(value?: VtmfFilingJob | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attempts': value['attempts'],
        'created_at': value['created_at'],
        'dta_id': value['dta_id'],
        'filing_job_id': value['filing_job_id'],
        'idempotency_key': value['idempotency_key'],
        'last_error': value['last_error'],
        'status': FilingJobStatusToJSON(value['status']),
        'updated_at': value['updated_at'],
        'vtmf_reference': value['vtmf_reference'],
    };
}
